import ArtifactGroupType from "@/roc/museum/base/ArtifactGroupType";

const BonnysBlade = {
  id: '95',
  name: 'Bonnys Blade',
  icon: 'BonnysBlade',
  groupIcon: 'LegendsOfTheHighSeas',
  type: ArtifactGroupType.LEGENDS_OF_THE_HIGH_SEAS,
  power: 25
};

export default BonnysBlade;
